/* eslint-disable angular/file-name */
/* eslint-disable angular/function-type */

angular
  .module('webtip.module')
  .directive('webtipAnalogChart', function () {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        items: '=',
        syncZoom: '='
      },
      controller: function ($scope, $element, $attrs, $timeout, __env) {
        $scope.__env = __env;
        $scope.$watch("syncZoom", function (extremes) {
          if (!$scope.chart.series.length) return;
          //When min and max are undefined. This is a zoom reset event
          if (!extremes.min && !extremes.max) {
            $scope.chart.series[0].xAxis.chart.zoomOut();
            //If synced min or max has changed. Set extremes for this chart
          } else if (extremes.min !== $scope.chart.xAxis[0].min || extremes.max !== $scope.chart.xAxis[0].max) {
            $scope.chart.series[0].xAxis.setExtremes(extremes.min, extremes.max);
          }
      }, false);

        $scope.$watch("items", function (newValue) {

          if ($scope.chart.yAxis.length > 0) {
            if ($scope.chart.series && $scope.chart.series.length > 0) {
              while ($scope.chart.series.length > 0) {
                $scope.chart.series[0].remove();
              }
            }
            _.each($scope.chart.yAxis, (yAxis) => {
              if (yAxis && typeof yAxis !== 'undefined') {
                if (yAxis.remove !== undefined) {
                  yAxis.remove(false);
                }
              }
            });
          }

          if (Object.keys(newValue).length === 0 || Object.keys(newValue) == ["length"]) {
            // reject("Not enough signals selected or analogSignals data is empty");
            return;
          }
          const analogSignals = [];
          const analogYAxis = {};
          while ($scope.chart.series.length > 0) {
            $scope.chart.series[0].remove();
          }
          _.each(Object.keys(newValue), (signal, signalIndex) => {
            const pointsWithMetadata = $scope.items[signal];
            if (pointsWithMetadata.signalMetadata.signalType !== 'ANALOG') return;

            const analogSignalSeries = {
              showInLegend: true,
              // Add all filters to name
              name: pointsWithMetadata.signalMetadata.name,
              pointStart: null,
              data: [],
            };

            const unit = pointsWithMetadata.signalMetadata.unit;
            analogSignalSeries.data = pointsWithMetadata.data;
            const yAxis = {
              opposite: signalIndex > 0 ? true : false,
              id: unit,
              title: {
                text: unit,
                style: {
                  maxWidth: '80px',
                  textOverflow: 'ellipsis',
                }
              },
              labels: {
                style: {
                  maxWidth: '80px',
                  textOverflow: 'ellipsis',
                },
                format: '{value} ' + unit,
              },
              softMin: 0,
              softMax: 5
            };

            if (analogSignalSeries.data.length !== 0) {
              analogSignalSeries.yAxis = unit;
              analogSignals.push(analogSignalSeries);
              if (typeof analogYAxis[unit] === "undefined")
                analogYAxis[unit] = yAxis;
            }
          });

          if ($scope.chart !== null) {

            // Add
            _.each(analogYAxis, (yAxis) => {
              // Don't add the same axis twice
              let found = $scope.chart.yAxis.find(item => item.userOptions.id === yAxis.id);
              if (!found) $scope.chart.addAxis(yAxis);
            });
            _.each(analogSignals, (series) => {
              $scope.chart.addSeries(series);
            });
          }
          $timeout(function () {
            $scope.chart.redraw();
            $scope.chart.reflow();
          }, 500);
        }, true);

      },
      template: '<div id="webtip-analog-chart" style="margin: 0 auto">not working</div>',
      link: function (scope, element, attrs) {
        if (scope.__env.profile === 'LU') {
          // Assumes that the RMM data in db is in UTC
          Highcharts.setOptions({
            time: {
              timezone:  DateTime.local().zoneName,
              useUTC: false,
              timezoneOffset: DateTime.local().offset
            }
          });
        } 
        scope.chart = new Highcharts.Chart({
          chart: {
            renderTo: "webtip-analog-chart",
            type: 'line',
            animation: false,
            zoomType: "x",
            events: {
              selection: function(event) {
                if (event && event.xAxis) {
                  const extremesObject = event.xAxis[0];
                  if (extremesObject.min && extremesObject.max) {
                    scope.syncZoom = extremesObject;
                  }
                }
              }
            },
          },
          title: {
            style: {
              maxWidth: '80px',
              textOverflow: 'ellipsis',
            },
            text: '',
          },

          tooltip: {
            shared: true,
          },

          credits: {
            enabled: false,
          },

          exporting: { enabled: false },

          plotOptions: {
            series: {
              animation: false,
              events: {
                legendItemClick: function () {
                  return false;
                }
              },
            }
          },

          yAxis: {
            opposite: true,
          },

          legend: {
            enabled: true,
          },

          xAxis: {
            crosshair: true,
            type: 'datetime',
            events: {
              setExtremes: function(event){
                //This triggers when reset zoom is pressed. in reset the event min and max are undefined
                if (!event.min && !event.max) {
                  scope.syncZoom = event;
                }
              }
            },
          },

          series: []
        });


      }
    }
  });
